import app from './app/app.js'
import sessionDocuments from './plugins/session-documents.js'

// import mediaQueries from './plugins/media-queries.js'
// import vh from './plugins/vh.js'

import CookiebarComponent from './components/cookiebar'
import DoclistComponent from './components/doclist'
import HeaderComponent from './components/header'
import RequestoverlayComponent from './components/requestoverlay'
import TopComponent from './components/top.js'

app
  .addComponent('cookiebar', CookiebarComponent)
  .addComponent('doclist', DoclistComponent)
  .addComponent('header', HeaderComponent)
  .addComponent('requestoverlay', RequestoverlayComponent)
  .addComponent('top', TopComponent)
  .init()

// media queries
// mediaQueries.add('small', '(max-width: 720px)')
// mediaQueries.add('medium', '(min-width: 721px) and (max-width: 1024px)')
// mediaQueries.add('large', '(min-width: 1025px) and (max-width: 1640px)')
// mediaQueries.add('wide', '(min-width: 1641px)')


// lead parameter
if (window.__lead) {
  sessionStorage.setItem('lead', window.__lead);
}
else {
  if (sessionStorage.getItem('lead')) {
    window.__lead = sessionStorage.getItem('lead');
  }
}

sessionDocuments.init()
